<template>
<div>
  <div v-if="!isM">
    <el-dialog :visible.sync="dialogVisible" :modal="modal" :destroy-on-close="true" @close="onclose"
    :title="evidenceName" top="10vh" class="dp-dialog">
      <previewPDF :evidenceType="evidenceType" :evidencePath="evidencePath" />
    </el-dialog>
  </div>
  <block v-else>
    <van-popup 
      v-model="dialogVisible" 
      position="bottom" 
      :style="{ height: 'calc(100vh - 48px)', top: '48px' }"
      :close-on-click-overlay="false"
      :safe-area-inset-bottom="false"
    >
      <div class="mobile-preview-wrapper">
        <!-- 顶部标题栏 -->
        <div class="mobile-preview-header">
          <div class="header-back" @click="onclose">
            <span class="back-icon">‹</span>
            <span class="back-text">返回</span>
          </div>
          <div class="header-title">{{ evidenceName }}</div>
          <div class="header-placeholder"></div>
        </div>
        <!-- 预览内容区域 -->
        <div class="mobile-preview-content">
          <previewPDF :evidenceType="evidenceType" :evidencePath="evidencePath" />
        </div>
      </div>
    </van-popup>
  </block>
</div>
  
</template>

<script>
import previewPDF from '@/components/previewPDF/previewPDF'
export default {
  components: { previewPDF },
  props: {
    // 是否有蒙层，当在弹出框里预览时（弹出框里打开弹出框），里面的弹出框不需要蒙层
    modal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      isM: this.$route.path.includes('m-'),
      evidenceName: '',
      evidencePath: '',
      evidenceType: ''
    }
  },
  methods: {
    open(p) {
      this.evidencePath = p.evidencePath
      this.evidenceType = p.evidenceType
      this.evidenceName = p.evidenceName
      this.dialogVisible = true
    },
    onclose() {
      this.dialogVisible = false
      this.evidencePath = ''
      this.evidenceType = ''
      this.evidenceName = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.dp-dialog {
  ::v-deep .el-dialog {
    width: 806px !important;

    .el-dialog__body {
      height: 680px !important;
      overflow-y: auto;
    }
  }
}

@media screen and (max-width: 1000px) {
  .dp-dialog {
  ::v-deep .el-dialog {
    width: 300px !important;

    .el-dialog__body {
      height: 250px !important;
      overflow-y: auto;
    }
  }
}
}

// 移动端预览样式
.mobile-preview-wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.mobile-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  z-index: 10;
  
  .header-back {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #333;
    font-size: 16px;
    min-width: 60px;
    
    .back-icon {
      font-size: 24px;
      font-weight: bold;
      margin-right: 4px;
      line-height: 1;
    }
    
    .back-text {
      font-size: 16px;
    }
    
    &:active {
      opacity: 0.6;
    }
  }
  
  .header-title {
    flex: 1;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 16px;
  }
  
  .header-placeholder {
    min-width: 60px;
  }
}

.mobile-preview-content {
  flex: 1;
  width: 100%;
  height: 0; // 使用flex布局时设置为0，让flex:1生效
  overflow: hidden;
  position: relative;
  
  ::v-deep .preview-container {
    height: 100%;
  }
}
</style>
